import { NgModule } from '@angular/core';
import { HighlightDirective } from './helpers/highlight.directive';

@NgModule({
    imports: [],
    declarations: [HighlightDirective],
    exports: [HighlightDirective]
})
export class DirectivesModule { }
